import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { BillItemPendingModel, PaymentBillItemPendingModel } from '@data-layer/models/payments';
import { MarineInsuranceHelperService } from '../../services';

@Component({
  selector: 'app-marine-insurance-payment-breakdown',
  templateUrl: './marine-insurance-payment-breakdown.component.html',
  styleUrls: ['./marine-insurance-payment-breakdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsurancePaymentBreakdownComponent {
  @Input() public pendingBills: PaymentBillItemPendingModel;
  @Input() public isPendingPaymentState: boolean;

  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;

  constructor(private marineInsuranceHelperService: MarineInsuranceHelperService) {}

  public get totalSum(): number {
    return (this.pendingBills?.items || []).reduce((acc: number, curr: BillItemPendingModel) => acc + curr.price * curr.quantity, 0) || 0;
  }

  public get joinedItems(): BillItemPendingModel[] {
    return this.marineInsuranceHelperService.getJoinedItems(this.pendingBills?.items);
  }
}
